import { render, staticRenderFns } from "./LoyaltyPoint.vue?vue&type=template&id=38e5526b&lang=html"
import script from "./LoyaltyPoint.vue?vue&type=script&lang=js"
export * from "./LoyaltyPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports